// control-quiz.js（複数クイズ対応＋問題画像＋質問省略対応）

const DEBUG = true;
const QUIZ_STORE = new Map();
const INITIALIZED_CONTAINERS = new Set();

function dlog(...args){ if(DEBUG) console.log(...args); }
function dgroup(label){ if(DEBUG) console.group(label); }
function dgroupEnd(){ if(DEBUG) console.groupEnd(); }

function getVarByName(varName){
  try {
    return eval('typeof ' + varName + ' !== "undefined" ? ' + varName + ' : undefined');
  } catch (e) { return undefined; }
}

function getJsonByScriptId(id){
  const node = document.getElementById(id);
  if(!node) return undefined;
  try {
    return JSON.parse(node.textContent.trim());
  } catch(e){
    console.error(`[quiz] JSON parse error in #${id}:`, e);
    return undefined;
  }
}

function loadQuizDataForSuffix(suffix){
  const varName = 'embeddedQuizData' + suffix;
  let data = getVarByName(varName);
  if (data) return data;
  data = getJsonByScriptId(varName);
  return data;
}

function initEmbeddedQuiz(quizData, containerId){
  dgroup(`🧩 initEmbeddedQuiz → ${containerId}`);
  if(!quizData){ dlog('❗quizDataが未定義'); dgroupEnd(); return; }

  const container = document.getElementById(containerId);
  if(!container){ dlog(`⚠️ コンテナ未検出: ${containerId}`); dgroupEnd(); return; }

  QUIZ_STORE.set(quizData.quizId, quizData);

  const optionsHTML = quizData.options.map((opt,i)=>
    `<button class="quiz-option-btn" data-index="${i}" onclick="answerEmbeddedQuiz(${i}, this, '${quizData.quizId}')">${opt}</button>`
  ).join('');

  // 👇 質問文と問題画像に対応（どちらも任意）
  const html = `
    <div class="embedded-quiz" id="embedded-quiz-wrapper-${quizData.quizId}">
      ${quizData.question ? 
        `<p class="embedded-quiz-question">${quizData.question}</p>` 
        : ''}
      ${quizData.questionImage ? 
        `<img src="${quizData.questionImage}" alt="問題画像" class="quiz-question-image">`
        : ''}
      <div class="quiz-options">${optionsHTML}</div>
      <div class="quiz-answer" id="quiz-answer-${quizData.quizId}">
        <p><strong>${quizData.explanation.answerText}</strong></p>
        ${quizData.explanation.image ? 
          `<img src="${quizData.explanation.image}" alt="説明画像" class="quiz-answer-image">` 
          : ''}
        ${quizData.explanation.additionalText ? 
          `<p class="quiz-additional-text">${quizData.explanation.additionalText}</p>` 
          : ''}
      </div>
    </div>`;

  container.innerHTML = html;
  INITIALIZED_CONTAINERS.add(containerId);
  dlog(`✅ 生成完了: ${quizData.quizId}`);
  dgroupEnd();
}

function answerEmbeddedQuiz(selectedIndex, buttonEl, quizId){
  dgroup(`📝 回答 → ${quizId}`);
  const wrap = document.getElementById(`embedded-quiz-wrapper-${quizId}`);
  const ans  = document.getElementById(`quiz-answer-${quizId}`);
  if(!wrap || !ans){ dlog('⚠️ ラッパー/解説未取得'); dgroupEnd(); return; }

  if(wrap.dataset.answered==='true'){ dlog('🚫 既に回答済み'); dgroupEnd(); return; }
  wrap.dataset.answered = 'true';

  const btns = wrap.querySelectorAll('.quiz-option-btn');
  btns.forEach(b=>b.classList.add('disabled'));

  const data = QUIZ_STORE.get(quizId);
  if(!data){ dlog('💥 QUIZ_STORE 取得失敗'); dgroupEnd(); return; }

  const isCorrect = selectedIndex === data.correctAnswer;
  if(isCorrect){ buttonEl.classList.add('correct'); }
  else{
    buttonEl.classList.add('incorrect');
    if(btns[data.correctAnswer]) btns[data.correctAnswer].classList.add('correct');
  }
  dlog(isCorrect ? '✅ 正解' : '❌ 不正解');

  try{
    localStorage.setItem(`quiz_${data.quizId}`, JSON.stringify({
      quizId: data.quizId,
      answer: data.options[selectedIndex],
      answerIndex: selectedIndex,
      isCorrect,
      timestamp: new Date().toISOString()
    }));
    dlog('🗂 保存OK');
  }catch(e){ console.error('💥 保存失敗', e); }

  setTimeout(()=>{ ans.classList.add('show'); dlog('📖 解説表示');
    setTimeout(()=>{ ans.scrollIntoView({behavior:'smooth', block:'nearest'}); dlog('🪄 スクロール'); },300);
  },500);
  dgroupEnd();
}

(function initAll(){
  dgroup('🧠 Embedded Quiz Initializer');
  const MAX_TRIES = 150;
  let tries = 0;

  function tick(){
  tries++;
  const nodes = Array.from(document.querySelectorAll('div[id^="quizContainer"]'));
  const pending = nodes.filter(n=>!INITIALIZED_CONTAINERS.has(n.id));

  // ⚠️ ノードもデータも無い状態が続く場合は停止
  if (nodes.length === 0 && tries > 10) {
    console.warn('⚠️ クイズコンテナが見つかりません。終了します。');
    dgroupEnd();
    return;
  }

  if (pending.length === 0) {
    dlog('✅ すべてのクイズコンテナを処理済み');
    dgroupEnd();
    return;
  }

  dlog(`⏳ 再試行 ${tries}/${MAX_TRIES}。未処理:`, pending.map(n=>n.id));

  pending.forEach(node=>{
    const suffix = node.id.replace('quizContainer','');
    const data = loadQuizDataForSuffix(suffix);
    if(data){
      dlog(`🔍 データ検出: embeddedQuizData${suffix||''} → ${node.id}`);
      initEmbeddedQuiz(data, node.id);
    }else{
      dlog(`… データ未定義: embeddedQuizData${suffix||''}`);
    }
  });

  if(tries < MAX_TRIES){
    setTimeout(tick, 200);
  }else{
    console.warn('⛔ 初期化タイムアウト。未処理コンテナ:', pending.map(n=>n.id));
    dgroupEnd();
  }
}

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
})();